export type DeviceCatalogReadView = {
  iconName: 'SquareArrowOutUpRightIcon';
  kind: 'link';
  label: string;
  to: '/device-catalog/active/$id/profile';
  params: {
    id: string;
  };
} | {
  kind: 'text';
  label: string;
} | {
  kind: 'empty';
};

/**
 * SDUI属性のvalue（カタログID）とdisplayValue（カタログ名）から閲覧表示を決める。
 * IDだけがある不完全なレスポンスではIDを画面へ露出せず、表示名だけならリンクなしで表示する。
 */
export function buildDeviceCatalogReadView(value: string | null | undefined, displayValue: string | null | undefined): DeviceCatalogReadView {
  if (!displayValue) return {
    kind: 'empty'
  };
  if (!value) return {
    kind: 'text',
    label: displayValue
  };
  return {
    iconName: 'SquareArrowOutUpRightIcon',
    kind: 'link',
    label: displayValue,
    to: '/device-catalog/active/$id/profile',
    params: {
      id: value
    }
  };
}